type TCorretagemCadastrada = { percentualCorretagem: number | null; valorCorretagem: number | null }

export type TCorretagemResolvida = { tipo: 'percentual' | 'valor'; valor: number }

type TOpcoesResolverCorretagem = {
  /**
   * Quando `true`, o tipo "valor" pode ser escolhido apenas pelo valor parametrizado, mesmo sem valor
   * na corretagem cadastrada (regra do Chile). Quando `false` (padrão, regra do Brasil), o tipo "valor"
   * só é escolhido se a corretagem cadastrada tiver um valor válido; caso contrário cai no fallback.
   */
  permitirValorApenasParametrizado?: boolean
}

/**
 * Resolve o tipo e o valor da corretagem seguindo a prioridade compartilhada entre Brasil e Chile:
 * percentual da corretagem cadastrada → percentual parametrizado → valor da corretagem cadastrada →
 * (Chile) valor parametrizado → fallback percentual 0.
 *
 * Retorna um formato normalizado (`tipo: 'percentual' | 'valor'`); cada país mapeia para o seu
 * próprio shape (ex.: o Chile traduz `'valor'` para `'uf'`).
 */
export const resolverCorretagem = (
  corretagemCadastrada: TCorretagemCadastrada | undefined,
  percentualParametrizado: number | null,
  valorParametrizado: number | null,
  { permitirValorApenasParametrizado = false }: TOpcoesResolverCorretagem = {},
): TCorretagemResolvida => {
  const percentual = corretagemCadastrada?.percentualCorretagem
  const valor = corretagemCadastrada?.valorCorretagem

  if (percentual != null || percentualParametrizado != null) {
    return { tipo: 'percentual', valor: percentual ?? percentualParametrizado ?? 0 }
  }

  const temValorCadastrado = valor != null && valor >= 0
  const temValorParametrizado = permitirValorApenasParametrizado && valorParametrizado != null

  if (temValorCadastrado || temValorParametrizado) {
    return { tipo: 'valor', valor: valor || (valorParametrizado ?? 0) }
  }

  return { tipo: 'percentual', valor: 0 }
}
